import { useContext, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import { GlobalContext } from "../../../../common/Context";
import { TRYP_SVGS } from "../../../../../constants";
import { text, white } from "../../../../../theme/colours";

const CategoryButton = ({
  subCategory,
  currSubCategory,
  setCurrSubCategory,
  isReady,
  setIsReady,
  categoryVids,
  setIsVideoLoad,
  isVideoLoad,
}) => {
  const { mobileView, tabletView } = useContext(GlobalContext);
  const active =
    subCategory.name.toLowerCase() === currSubCategory.toLowerCase();

  const mobileBtn = {
    minWidth: "0",
    mr: "2.5rem",
    p: active ? "0 0 6px 0" : "0 0 10px 0",
    borderBottom: active && `solid 4px ${subCategory.logoColor}`,
    borderRadius: "0px",
    textTransform: "none",
    opacity: isReady ? "100%" : "50%",
  };
  const mobileText = {
    fontSize: "0.8rem",
    fontWeight: 900,
    color: text.primary,
    textTransform: "capitalize",
  };

  const btnStyle = {
    display: "flex",
    background: active ? subCategory.logoColor : white,
    justifyContent: "flex-start",
    alignItems: "center",
    width: "fit-content",
    height: "fit-content",
    m: mobileView || tabletView ? "0 2rem 2rem 0" : "0 1.25rem 2rem 0",
    p: "3px",
    borderRadius: "50px",
    opacity: isReady ? "100%" : "50%",
  };

  const logoCircle = {
    display: "flex",
    justifyContent: "center",
    borderRadius: "50%",
    p: "0.5rem",
    mr: "0.5rem",
    "& svg": {
      width: "15px",
      height: "15px",
    },
  };
  const textStyle = {
    mr: mobileView ? "2.5rem" : "1.5rem",
    fontWeight: 600,
    textTransform: "capitalize",
  };

  const handleCatSwap = () => {
    setIsReady(false);
    setCurrSubCategory(subCategory?.name);
  };

  useEffect(() => {
    setIsVideoLoad(0);
  }, [currSubCategory]);

  useEffect(() => {
    if (categoryVids.length !== 0) {
      isVideoLoad === categoryVids.length && setIsReady(true);
    }
  }, [isVideoLoad]);

  return mobileView ? (
    <Button sx={mobileBtn} onClick={isReady ? () => handleCatSwap() : null}>
      <Typography sx={mobileText} variant="h4">
        {subCategory.name}
      </Typography>
    </Button>
  ) : (
    <ReBox
      style={btnStyle}
      button={true}
      clickHandler={() => handleCatSwap()}
      disabled={!isReady || active}>
      <Box
        sx={{
          ...logoCircle,
          bgcolor: active ? white : subCategory.logoColor,
          "& svg *": {
            fill: active ? subCategory.logoColor : white,
          },
        }}>
        {TRYP_SVGS[subCategory.img]}
      </Box>
      <Typography
        variant="h4"
        color={active ? white : subCategory.logoColor}
        sx={textStyle}>
        {subCategory.name}
      </Typography>
    </ReBox>
  );
};

export default CategoryButton;
